/**
 * Ruta `/aviso-de-privacidad` (006 · T051 · US5): el aviso aceptado, leído desde el Perfil.
 *
 * Misma puerta que `/perfil` (`allowSuspended: true`): de solo lectura también con la empresa
 * suspendida. Barra de pestañas con Perfil activa (FR-001).
 */
import { createFileRoute } from '@tanstack/react-router';

import { PrivacyUpdateScreen } from '../features/access/privacy-update';
import { PrivacyNoticeLoading, PrivacyNoticePage } from '../features/profile/privacy-notice-page';
import { GateFallback } from '../features/shell/gate-fallback';
import { useAccessGate } from '../features/shell/use-access-gate';
import { t } from '../i18n';

export function AvisoDePrivacidadGate() {
  const gate = useAccessGate({ allowSuspended: true });

  if (gate.status === 'LOADING') {
    return <PrivacyNoticeLoading />;
  }
  if (gate.status === 'OFFLINE' || gate.status === 'ERROR') {
    return <GateFallback status={gate.status} retry={gate.retry} active="profile" title={t('profile.notice.title')} />;
  }
  if (gate.status === 'PRIVACY_PENDING') {
    return <PrivacyUpdateScreen version={gate.me.privacy_notice.version} />;
  }
  return <PrivacyNoticePage />;
}

export const Route = createFileRoute('/aviso-de-privacidad')({
  component: AvisoDePrivacidadGate,
});
